/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { TextArea } from 'semantic-ui-react';

import FieldLayout from '../FieldLayout/FieldLayout';

import styles from './TextArea.less';

class TextAreaField extends Component {
  handleChange = (event, { value }) => {
    const {
      field: { name },
      form: { setFieldValue },
      onChange,
    } = this.props;
    if (onChange) {
      onChange(value);
    }
    setFieldValue(name, value);
  };

  handleBlur = () => {
    const {
      field: { name },
      form: { setFieldTouched },
    } = this.props;
    setFieldTouched(name);
  };

  render() {
    const {
      maxlengthchar,
      label,
      field: { name, value },
      errorInline,
      ...props
    } = this.props;
    const error =
      value && value.length > +maxlengthchar
        ? `The maximum is ${maxlengthchar} characters long`
        : null;

    return (
      <FieldLayout name={name} label={label} errorInline={errorInline}>
        <div className={styles.content}>
          <TextArea
            rows={4}
            value={value}
            onChange={this.handleChange}
            maxLength={maxlengthchar}
            onBlur={this.handleBlur}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
          {maxlengthchar && (
            <span className={error ? styles.countRed : styles.count}>
              {value ? `${value.length}/${maxlengthchar}` : `0/${maxlengthchar}`}
            </span>
          )}
        </div>
      </FieldLayout>
    );
  }
}

export default TextAreaField;
